import { Component, Input, OnInit } from '@angular/core';
import {
  getRedemptionCodeStatusDisplay,
  RedemptionCode,
  RedemptionCodeSet,
  RedemptionCodeSetStatus, RedemptionCodeStatus
} from '../../../../../../../../models/redemption-code';
import { CallbackResult, CallbackResultStatus, generateCsvDownload, getISO8601DateString } from '../../../../../../../../utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-export-redemption-codes-modal',
  templateUrl: './export-redemption-codes-modal.component.html',
  styleUrls: ['./export-redemption-codes-modal.component.css']
})
export class ExportRedemptionCodesModalComponent implements OnInit {
  @Input() redemptionCodeSet: RedemptionCodeSet;
  @Input() redemptionCodes: RedemptionCode[];
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public defaultDownloadFileName: string;
  public downloadFileName: string;

  public loadingSubmit = false;

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.defaultDownloadFileName = 'Redemption_Code' + '_Export_' + getISO8601DateString(new Date()) + '.csv';
    this.downloadFileName = this.defaultDownloadFileName;
  }

  public handleSubmit() {
    this.loadingSubmit = true;

    if (!this.downloadFileName) {
      this.downloadFileName = this.defaultDownloadFileName;
    }

    const content: any[][] = [
      [
        'Code',
        'Redemption URL',
        'Status',
        'Redeemed At',
        'Redeemed By ID',
        'Redeemed By First Name',
        'Redeemed By Last Name',
        'Redeemed By Birthday',
        'Redeemed For ID',
        'Redeemed For First Name',
        'Redeemed For Last Name',
        'Redeemed For Birthday',
      ]
    ];

    for (const rc of this.redemptionCodes) {
      let status = 'Unknown';
      switch (rc.status) {
        case RedemptionCodeStatus.available:
          if (this.redemptionCodeSet.status === RedemptionCodeSetStatus.expired) {
            status = 'Expired';
          } else {
            status = 'Available';
          }
          break;
        case RedemptionCodeStatus.redeemed:
          status = 'Redeemed';
          break;
        case RedemptionCodeStatus.expired:
          status = 'Manually Expired';
          break;
      }

      content.push([
        rc.code,
        rc.redemption_url,
        status,
        rc.redeemed_at,
        rc.redeemed_by_id,
        rc.redeemed_by_first_name,
        rc.redeemed_by_last_name,
        rc.redeemed_by_birthday,
        rc.redeemed_for_id,
        rc.redeemed_for_first_name,
        rc.redeemed_for_last_name,
        rc.redeemed_for_birthday,
      ]);
    }

    generateCsvDownload(content, this.downloadFileName);

    this.savedCallback({
        text: 'Redemption code export downloaded successfully.',
        status: CallbackResultStatus.success
      });
    this.activeModal.close();
  }
}
